import type { IconProps } from '../types';

const DoublePathArrow = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M8.69247 22.1538L10.5002 24L18.3335 16L10.5002 8L8.69247 9.84615L14.7181 16L8.69247 22.1538Z" />
    <path d="M15.6925 22.1538L17.5002 24L25.3335 16L17.5002 8L15.6925 9.84615L21.7181 16L15.6925 22.1538Z" />
  </svg>
);

export default DoublePathArrow;
